import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PeopleService } from '../../services/people/people.service';
import { PeopleHelpModalComponent } from '../../components/people-help-modal/people-help-modal.component';
import { EditStatusModalComponent } from '../../components/edit-status-modal/edit-status-modal.component';
import { BsModalService, BsModalRef} from 'ngx-bootstrap/modal'
import { AlertBannerService, AlertType } from '../../lib/alert-banner/alert-banner.service';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
import {PermissionsService} from "../../services/permissions/permissions.service";
import * as _ from 'lodash';
import PhoneInputService from 'src/app/lib/phone-input/phone-input.service';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import { SelectRequestModalComponent } from 'src/app/components/select-request-modal/select-request-modal.component';
import * as Cookies from 'js-cookie';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { SelectCheckTypeModalComponent } from 'src/app/components/select-check-type-modal/select-check-type-modal.component';
import { WarningModalContentComponent } from '../../lib/warning-modal/warning-modal.component';
import { ErrorModalContentComponent } from 'src/app/lib/error-modal/error-modal.component';
import { MultiEditServiceInterface } from 'src/app/services/people/people.service.interfaces';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
@Component({
  selector: 'app-people',
  templateUrl: './people.component.pug',
  styleUrls: ['./people.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PeopleComponent implements OnInit {
  searchOptions = [{
    'label': $localize`Name`,
    'hint': $localize`First or last name`,
    'value': 'name'
  }, {'label': $localize`Email`, 'hint': $localize`Email address`, 'value': 'email'}, {
    'label': $localize`Location`,
    'hint': $localize`Suburb, town or city`,
    'value': 'location'
  }];
  searchOptionsTalentPool = [{
    'label': $localize`Name`,
    'hint': $localize`First or last name`,
    'value': 'name'
  }, {'label': $localize`Email`, 'hint': $localize`Email address`, 'value': 'email'}, {
    'label': $localize`Organisation`,
    'hint': $localize`Organisation name`,
    'value': 'organisation_name'
  }, {
    'label': $localize`Role`,
    'hint': $localize`Job title`,
    'value': 'job_title'
  }];
  sortOptions = [
    {
      'label':$localize`Last activity`,
      'type': "number",
      'value':"activities"
    },
    {
      'label':$localize`Name`,
      'type': "word",
      'value':"name"
    },
    {
      'label':$localize`Selected profiles`,
      'type': "grouped",
      'value':"grouped"
    }
  ];
  sortOptionsUpdated = [
    {
      'label':$localize`Last activity`,
      'type': "number",
      'value':"activities"
    },
    {
      'label':$localize`Name`,
      'type': "word",
      'value':"name"
    }
  ];
  sortOptionsTalentPool = [
    {
      'label': $localize`Opt-in date`,
      'type': "optin",
      'value': "opt_in"
    },
    {
      'label': $localize`Name`,
      'type': "word",
      'value': "name"
    }
  ];
  filterCheckboxTitle = $localize`People:`;
  filterCheckboxOptions = [
    {'label': $localize`Verified`, 'value': 'verified'}
  ];
  filterStatusTitle = $localize`Rehire status:`;
  filterStatusOptions = [
    {'label': $localize`Target`, 'value': 'Target'},
    {'label': $localize`Potential target`, 'value': 'Potential target'},
    {'label': $localize`No target`, 'value': 'No target'},
    {'label': $localize`Unknown`, 'value': 'Unknown'},
  ];

  filterToggleGroups = [
    {
      title: 'Target status',
      key: 'status',
      options: [
        {label: $localize`Target`, value: 'Target'},
        {label: $localize`Potential target`, value: 'Potential target'},
        {label: $localize`No target`, value: 'No target'},
        {label: $localize`Unknown`, value: 'Unknown'},
      ]
    },
    {
      title: 'Opted in as',
      key: 'optedIn',
      options: [
        {label: $localize`Candidate`, value: 'Candidate'},
        {label: $localize`Potential candidate`, value: 'Potential candidate'},
        {label: $localize`Ex-employee`, value: 'Ex-employee'},
      ]
    }
  ];
  filterByOptions = [{'key': 'Last activity', 'value': $localize`Last activity`}, {'key': 'Date added', 'value': $localize`Date added`}];
  filterDefaults = [{'key': 'Last activity', 'value': $localize`Last activity`}];
  filterBy = this.filterByOptions[0]['key'];
  selectedTab = 'all';
  people: any[] = [];
  total = 0;
  searchOutput=undefined;
  sortString = '-activities';
  rowsPerView = 20;
  currentPage = 1;
  filterOutput:any = {};
  helpModal: BsModalRef = new BsModalRef();
  editModal: BsModalRef = new BsModalRef();
  selectCheckTypeModal: BsModalRef = new BsModalRef();
  editWarningModal: BsModalRef = new BsModalRef();
  peopleFilter = 'all';
  filter = 'All';
  start!: any;
  end!: any;
  loading = true;
  loadingDepartments = false
  noData = false;
  initialDataRequest = true;
  isEditButton=false;
  dataFiltered = false;
  selectedColumns: any = [];
  addOrder = 0;
  selectMode = false;
  selectAllPage = false;
  selectAllTotal = false;
  selectedPeople: any[] = [];
  selectedPeopleAll: any[] = [];
  allInMemory = false;
  noPermissionToSend = false;
  status: any;
  bsModalRef:any;
  filterByVar = "Last Activity";
  validSelectedPeople: any[] = [];
  invalidSelectedPeople: any[] = [];
  org_uid = Cookies.get(ConstantsService.ORG_COOKIE);
  searchTags: any = [];
  searchTitle = $localize`Sorry, we couldn’t find any results`
  searchDescription = $localize`Try another search term or adjust the filters.`
  searchImg = 'https://assets.xref.com/omni/shared/tmp_console_no_vendors.svg'
  canEditPeopleProfile = false;
  heading = $localize`Request access`;
  subHeading = $localize`Access this page upon being granted permission.`;
  btnText = $localize`Request access`;
  noPermission = false;
  canViewPeople = false;
  canViewContactAccountManagerLink = false;
  requestTemplate = false;
  ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT = false;
  locationInput = 'Location';
  distanceInput = 'Distance';
  dateInput = 'Opt-in date';

  constructor( private peopleService: PeopleService,
               private modalService: BsModalService,
               private alertList: AlertBannerService,
               private router: Router,
               private planservice:PlanService,
               private permissions: PermissionsService,
               public organisationService: OrganisationService,
               ) { }

  ngOnInit(): void {
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT = this.permissions.isFeatureActivated('ent-10167-add-target-status-to-multi-edit');
    this.canEditPeopleProfile = this.permissions.hasPermission('can_edit_people_profile')
    this.canViewPeople = this.permissions.hasPermission('can_view_people_list')
    if(!this.canViewPeople){
      this.noPermission = true;
    }
    this.canViewContactAccountManagerLink = this.permissions.hasPermission(
      'can_access_subscription_contact_account_manager_link')
    this.filterStatusTitle = $localize`Target status`
    this.filterByVar = $localize`Last activity`

    this.noPermissionToSend = !this.canSendRequest()
    if(this.canViewPeople){
      this.getFilterDepartments()
    }
    else{
      this.loadingDepartments = false
    }
    let selectedTab = localStorage.getItem('people-page-selected-tab');
    if (selectedTab) {
      this.selectedTab = selectedTab;
      if (selectedTab == 'talent_pool') {
        this.sortString = '-opt_in';
      }
    }
    let filterOptions = localStorage.getItem('people-filters');
    if (filterOptions) {
      this.filterOutput = JSON.parse(filterOptions);
    }
    if (this.selectedTab === 'talent_pool') {
     this.getTalentPoolFilters();
    }

    // We only need to manually call onSelectTab for the 'all' tab
    if (this.selectedTab === 'all') {
      this.onSelectTab({id: this.selectedTab});
    }
  }

  getTalentPoolFilters() {
    const stateStr = localStorage.getItem('talent-pool-filters');

    if (stateStr) {
      const state = JSON.parse(stateStr);

      this.filterOutput['filter'] = state.filter;
      this.filterOutput['start_date'] = state.start ? moment(state.start) : this.start;
      this.filterOutput['end_date'] = state.end ? moment(state.end) : this.end;
      this.filterOutput['statusOption'] = Object.keys(state.selectedStatusFilters).filter(key => state.selectedStatusFilters[key]);
      this.filterOutput['optInOption'] = Object.keys(state.selectedOptedInFilters).filter(key => state.selectedOptedInFilters[key]);
      this.filterOutput['location'] = state.textValueLocation || '';
      this.filterOutput['distance'] = state.selectedDistance;
    } else {
      this.filterOutput['filter'] = $localize`Last 30 days`;
      this.filterOutput['start_date'] = moment().startOf('day').subtract(30, 'days');
      this.filterOutput['end_date'] = moment();
      this.filterOutput['statusOption'] = ['Target', 'Potential target'];

      delete this.filterOutput['optInOption'];
      delete this.filterOutput['location'];
      delete this.filterOutput['distance'];
    }
  }

  canSendRequest() {
    const permissions = [
      'can_send_reference_requests',
      'can_send_pulse_requests',
      'can_send_exit_requests',
      'can_send_backgroundcheck_requests',
      'can_send_reference_requests_with_survey_perms',
      'can_send_pulse_requests_with_survey_perms',
      'can_send_exit_requests_with_survey_perms',
      'can_send_backgroundcheck_requests_with_survey_perms'
    ]
    return permissions.some((permission) => this.permissions.hasPermission(permission));
  }

  getFilterDepartments(): void{
    this.loadingDepartments = true
    this.organisationService.getAllDetailedDepartments().subscribe((res) => {
      this.loadingDepartments = false
      this.organisationService.SetPrefectehedDepartment({data:res})
    },
    (error) => {
      this.loadingDepartments = false
      this.organisationService.SetPrefectehedDepartment({data: {departments: [] }})
    }
    )
  }

  initialisePeople(){
    this.peopleService.getPeople(
      this.searchOutput,
      this.sortString,
      this.rowsPerView,
      this.currentPage,
      this.filterOutput,
      this.status,
      this.selectedPeople.map(e => e.uid).join(',')
    ).subscribe(res=>{
        this.loading = false;
        this.total = res['data']['total'];
        if (this.sortString.match('-?grouped')) {
          this.total += this.selectedPeople.length;
        }
        this.people = res['data']['people'];
        if (this.sortString && (this.sortString === 'grouped' || this.sortString === '-grouped')) {
          this.sortSelectedGroups()
        } else {
          this.people.forEach((person, index) => {
            if (this.selectedPeople.some(s => s.uid === person.uid)){
              person.selected = true;
            }
          })
        }
        this.noPermission = false
    }, error => {
      if (error.status === 403) {
        this.people = []
        this.total = 0
        this.noPermission = true;
      } else {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
        this.loading = false;
      });
  }

  initialiseTalentPool() {
    const serviceMethod = this.peopleService.getTalentPool.bind(this.peopleService);
    serviceMethod(
      this.searchOutput,
      this.sortString,
      this.rowsPerView,
      this.currentPage,
      this.filterOutput).subscribe(res => {
      this.loading = false;
      this.total = res['data']['total'];
      if (this.sortString.match('-?grouped')) {
        this.total += this.selectedPeople.length;
      }
      this.people = res['data']['people'];
      if (this.sortString && (this.sortString === 'grouped' || this.sortString === '-grouped')) {
        this.sortSelectedGroups()
      } else {
        this.people.forEach((person, index) => {
          if (this.selectedPeople.some(s => s.uid === person.uid)) {
            person.selected = true;
          }
        })
      }
      this.noPermission = false
    }, error => {
      if (error.status === 403) {
        this.people = []
        this.total = 0
        this.noPermission = true;
      } else {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
      this.loading = false;
    });
  }
  openHelpModal(){
    this.helpModal = this.modalService.show(
      PeopleHelpModalComponent,
      Object.assign({}, { class: 'modal-dialog-centered modal-custom' }),
    )
  }

  openEditModal(){
    if (this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT) {
      this.getSelectedPeopleEdit();
    } else {
      this.deprecatedGetSelectedPeopleEdit();
    }
  }

  deprecatedGetSelectedPeopleEdit() {
    if (!this.allInMemory && this.selectAllTotal) {
      this.loading = true;
      this.peopleService.getPeople(
        this.searchOutput,
        this.sortString,
        5000,
        this.currentPage,
        this.filterOutput,
        this.status
      ).subscribe(res=>{
        this.selectedPeopleAll = res['data']['people']
        this.peopleService.selectedPeople = this.selectedPeopleAll;
        this.allInMemory = true;
        this.displayEditModal();
        this.loading = false;
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
        this.loading = false;
      });
    } else {
      this.displayEditModal();
    }
  }

  getSelectedPeopleEdit(): void {
    // If data is already in memory, just display the modal
    if (this.allInMemory || !this.selectAllTotal) {
      this.displayEditModal();
      return;
    }

    // Fetch all people data before displaying modal
    this.loading = true;

    const peopleRequest$ = this.selectedTab === 'talent_pool'
      ? this.peopleService.getTalentPool(
        this.searchOutput,
        this.sortString,
        5000,
        this.currentPage,
        this.filterOutput
      )
      : this.peopleService.getPeople(
        this.searchOutput,
        this.sortString,
        5000,
        this.currentPage,
        this.filterOutput,
        this.status
      );

    peopleRequest$.subscribe({
      next: (res) => {
        this.selectedPeopleAll = res['data']['people'];
        this.peopleService.selectedPeople = this.selectedPeopleAll;
        this.allInMemory = true;
        this.displayEditModal();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching people for edit:', error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
        this.loading = false;
      }
    });
  }

  getSelectedPeopleSendXref() {
    if (!this.allInMemory && this.selectAllTotal && this.total <= 5000) {
      this.loading = true;
      if (this.selectedTab == 'talent_pool') {
        const serviceMethod = this.peopleService.getTalentPool.bind(this.peopleService);
        serviceMethod(
          this.searchOutput,
          this.sortString,
          5000,
          this.currentPage,
          this.filterOutput,
        ).subscribe(res => {
          this.selectedPeopleAll = res['data']['people']
          this.peopleService.selectedPeople = this.selectedPeopleAll;
          this.updateSelectedPeopleEmails();
          this.formatSelectedPeopleData();
          this.allInMemory = true;
          this.openSelectReferenceModal();
          this.loading = false;
        }, error => {
          console.log(error);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.loading = false;
        });
      }
      else {
        this.peopleService.getPeople(
          this.searchOutput,
          this.sortString,
          5000,
          this.currentPage,
          this.filterOutput,
          this.status
        ).subscribe(res => {
          this.selectedPeopleAll = res['data']['people']
          this.peopleService.selectedPeople = this.selectedPeopleAll;
          this.updateSelectedPeopleEmails();
          this.formatSelectedPeopleData();
          this.allInMemory = true;
          this.openSelectReferenceModal();
          this.loading = false;
        }, error => {
          console.log(error);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.loading = false;
        });
      }
    }
  }

  formatSelectedPeopleData() {
    this.peopleService.selectedPeople.forEach(s => {
      if (s.end_date) {
        let date = moment(s.end_date, 'YYYY-MM-DD');
        s.end_date_month = date.month();
        s.end_date_year = date.year();
      } else {
        s.end_date_month = null;
        s.end_date_year = null;
      }

      if (s.mobile) {
        const phone = PhoneInputService.setCountryCode(s.mobile);
        s.mobile_phone = phone.phoneNumber;
        s.country_code = phone.callingCode;
      } else {
        s.mobile_phone = '';
      }

      if (s.country_code) {
        s.country_code = s.country_code;
      } else {
        s.country_code = '';
      }
    });
  }

  displayEditModal() {
    this.editModal = this.modalService.show(
      EditStatusModalComponent,
      Object.assign({}, {
        class: 'modal-dialog-centered',
        id: 1,
        initialState: {
          selectedPeople: this.selectAllTotal ? this.selectedPeopleAll : this.selectedPeople
        }
      }),
    )
    this.editModal.content.nextClick.subscribe(res => {
      if (res.status && res.status.value == 'Ex-employee') {
        const selected_uids = this.selectAllTotal ? this.selectedPeopleAll.map(e => e.uid) : this.selectedPeople.map(e => e.uid);
        const payload = {
          'uids': selected_uids,
          'status': res.status.label,
          'employment_end_date': moment(res.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        this.peopleService.validatePeopleProfiles(payload).subscribe(resp => {
          this.validSelectedPeople = resp['valid'];
          this.invalidSelectedPeople = resp['invalid'];
          this.updatePeopleWithWarning(res);
        });
      }
      else{
        this.updatePeopleWithWarning(res);
     }
    });
  }

  getWarningModalState(response) {
    let initialState = {};
    let totalPeople = 0;
    if (this.selectedPeopleAll.length > 0) {
      if (this.total >= 5000) {
        totalPeople = 5000;
      } else {
        totalPeople = this.total;
      }
    } else {
      totalPeople = this.selectedPeople.length;
    }
    if (response.status) {
      const title = $localize`Change profile status?`
      if (response.status.value == 'Candidate') {
        initialState = {
          'title': title,
          'message': $localize`You are changing the profile status of ${totalPeople} ${totalPeople>1?`people`:`person`} to candidate. This action will clear any previously entered data for employment start and end date. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Employee') {
        initialState = {
          'title': title,
          'message': $localize`You are changing the profile status of ${totalPeople} ${totalPeople > 1 ? `people` : `person`} to employee. This action will replace any previously entered data for employment start date with ${response.date} and clear any existing data for employment end date. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length > 0 && this.invalidSelectedPeople.length > 0) {

        initialState = {
          'title': title,
          'message': $localize`This action will replace any previously entered data for employment end date with ${response.date} for ${this.validSelectedPeople.length} ${this.validSelectedPeople.length > 1 ? `people` : `person`}. ${this.invalidSelectedPeople.length} ${this.invalidSelectedPeople.length > 1 ? `people` : `person`} ${this.invalidSelectedPeople.length > 1 ? `have` : `has`} an employment start date after ${response.date} and will not be updated. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length > 0 && this.invalidSelectedPeople.length == 0) {
        initialState = {
          'title': title,
          'message': $localize`This action will replace any previously entered data for employment end date with ${response.date} for ${this.validSelectedPeople.length} ${this.validSelectedPeople.length>1?`people`:`person`}. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length == 0 && this.invalidSelectedPeople.length > 0) {
        initialState = {
          'title': $localize`Error changing status`,
          'message': $localize`You are attempting to change the profile status of ${totalPeople} ${this.invalidSelectedPeople.length<2?`person`:`people`} to ex-employee. All selected profiles have an employee start date after ${response.date} and cannot be updated.`,
          // 'disableAgree': true
        }
      }
    }
    else {
      initialState = {
        'title': $localize`Change profile department?`,
        'message': $localize`You are changing the department of ${totalPeople} people to ${response.department.value}. Are you sure you want to continue?`
      }
    }
    return initialState;
  }

  deprecatedGetWarningModalState(response) {
    let initialState = {};
    if (response.status) {
      const title = $localize`Change profile status?`
      if (response.status.value == 'Candidate') {
        initialState = {
          'title': title,
          'message': $localize`You are changing the profile status of ${this.selectedPeople.length} ${this.selectedPeople.length>1?`people`:`person`} to candidate. This action will clear any previously entered data for employment start and end date. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Employee') {
        initialState = {
          'title': title,
          'message': $localize`You are changing the profile status of ${this.selectedPeople.length} ${this.selectedPeople.length > 1 ? `people` : `person`} to employee. This action will replace any previously entered data for employment start date with ${response.date} and clear any existing data for employment end date. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length > 0 && this.invalidSelectedPeople.length > 0) {

        initialState = {
          'title': title,
          'message': $localize`This action will replace any previously entered data for employment end date with ${response.date} for ${this.validSelectedPeople.length} ${this.validSelectedPeople.length > 1 ? `people` : `person`}. ${this.invalidSelectedPeople.length} ${this.invalidSelectedPeople.length > 1 ? `people` : `person`} ${this.invalidSelectedPeople.length > 1 ? `have` : `has`} an employment start date after ${response.date} and will not be updated. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length > 0 && this.invalidSelectedPeople.length == 0) {
        initialState = {
          'title': title,
          'message': $localize`This action will replace any previously entered data for employment end date with ${response.date} for ${this.validSelectedPeople.length} ${this.validSelectedPeople.length>1?`people`:`person`}. Are you sure you want to continue?`
        }
      }
      else if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length == 0 && this.invalidSelectedPeople.length > 0) {
        initialState = {
          'title': $localize`Error changing status`,
          'message': $localize`You are attempting to change the profile status of ${this.selectedPeople.length} ${this.invalidSelectedPeople.length<2?`person`:`people`} to ex-employee. All selected profiles have an employee start date after ${response.date} and cannot be updated.`,
          // 'disableAgree': true
        }
      }
    }
    else {
      initialState = {
        'title': $localize`Change profile department?`,
        'message': $localize`You are changing the department of ${this.selectedPeople.length} people to ${response.department.value}. Are you sure you want to continue?`
      }
    }
    return initialState;
  }

  updatePeopleWithWarning(response) {
    let initialState;

    if (this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT) {
      initialState = this.getWarningModalState(response);
    } else {
      initialState = this.deprecatedGetWarningModalState(response);
    }

    if (response.status.value == 'Ex-employee' && this.validSelectedPeople.length == 0 && this.invalidSelectedPeople.length > 0) {
      this.editWarningModal = this.modalService.show(ErrorModalContentComponent,
        { id: 2, class: 'modal-dialog-centered show default-modal', initialState }
      );
    }
    else {
      this.editWarningModal = this.modalService.show(WarningModalContentComponent,
        { id: 2, class: 'modal-dialog-centered show default-modal', initialState }
      );
      this.editWarningModal.content.closeBtnName = 'Cancel';
      this.editWarningModal.content.agreeButton = 'Continue';
      this.editWarningModal.content.selection.subscribe(res => {
        if (res) {
          if (this.selectAllTotal) {
            this.updatePeople(this.selectedPeopleAll, response);
          } else {
            this.updatePeople(this.selectedPeople, response);
          }
        } else {
          // This setTimeout introduces a brief delay to address backdrop rendering issue.
          setTimeout(() => {
            this.displayEditModal()
          }, 500);
          }
      });
    }

  }

  updatePeople(peopleArray, res) {
    // Check if we should use async flow for large updates
    const ASYNC_THRESHOLD = 5000;

    // Only use new async flow if feature flag is active
    if (this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT
        && this.selectAllTotal
        && this.total >= ASYNC_THRESHOLD) {
      // Use async flow
      this.updatePeopleAsync(res);
      return;
    }

    let validPeopleArray = []
    validPeopleArray = peopleArray.filter(e => {
      if (res.status.value != 'Ex-employee') {
        return e;
      } else if (res.status.value == 'Ex-employee' && this.validSelectedPeople.includes(e.uid)) {
        return e;
      }
    })
    let department_and_dates = {};
    if (res.department) {
      department_and_dates = { 'department': res.department.label };
    }
    if (res.status) {
      if (res.status.label == 1) {
        department_and_dates['employment_start_date'] = moment(res.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      else if (res.status.label == 0) {
        department_and_dates['employment_end_date'] = moment(res.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }

    // Handle rehire status if feature flag is active and status is Candidate
    if (this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT
        && res.status && res.status.value === 'Candidate' && res.rehireStatus) {
      department_and_dates['rehire_status'] = res.rehireStatus.label;
    }

    let params: MultiEditServiceInterface = {}

    let shouldCreateParams = false;
    shouldCreateParams = res.status ? true : false;
    if (shouldCreateParams) {
      params = {
        data: validPeopleArray,
        status: res?.status?.label,
        department_and_dates: department_and_dates
      }
    }
    this.peopleService.updatePeople(params).subscribe(res => {
      if (params.status == 0 && this.invalidSelectedPeople.length > 0) {
        let message='';
        if (this.invalidSelectedPeople.length > 1 && this.validSelectedPeople.length > 1) {
          message = $localize`Success! ${this.validSelectedPeople.length} profiles have been updated. ${this.invalidSelectedPeople.length} were not updated and remain selected.`
        }
        else if (this.invalidSelectedPeople.length > 1 && this.validSelectedPeople.length == 1) {
          message = $localize`Success! ${this.validSelectedPeople.length} profile has been updated. ${this.invalidSelectedPeople.length} were not updated and remain selected.`
        }
        else if (this.invalidSelectedPeople.length == 1 && this.validSelectedPeople.length >1) {
          message = $localize`Success! ${this.validSelectedPeople.length} profiles have been updated. ${this.invalidSelectedPeople.length} was not updated and remains selected.`
        }
        else if (this.invalidSelectedPeople.length == 1 && this.validSelectedPeople.length == 1) {
          message = $localize`Success! ${this.validSelectedPeople.length} profile has been updated. ${this.invalidSelectedPeople.length} was not updated and remains selected.`
        }

        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: message,
          keepOnRouteChange: true
        }]);
        this.setSelectMode(true)
        this.people.forEach((person, index) => {
          if(this.invalidSelectedPeople.includes(person.uid)){
            person.selected = true;
          }
        });
        this.selectedPeople = this.people.filter(p => p.selected === true);
        this.peopleService.selectedPeople = this.selectedPeople;
      }
      else if (params.status == 0 && this.invalidSelectedPeople.length == 0) {

        let message = this.validSelectedPeople.length > 1 ? $localize`Success! ${this.validSelectedPeople.length} profiles have been updated.` : $localize`Success! ${this.validSelectedPeople.length} profile has been updated.`;

        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: message,
          keepOnRouteChange: true
        }]);
      }
      else {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Selected profiles have been updated.`,
          keepOnRouteChange: true
        }]);
        this.clearSelectAll();
        this.onSelectTab({ 'id': this.selectedTab });
      }
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.loading = false;
    });
    this.setSelectMode(false)
  }

  updatePeopleAsync(res) {
    // Async update for 5000+ profiles using filters instead of UIDs

    this.loading = true;

    let department_and_dates = {};

    if (res.department) {
      department_and_dates['department'] = res.department.label;
    }

    if (res.status) {
      if (res.status.label == 1) {
        department_and_dates['employment_start_date'] = moment(res.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      } else if (res.status.label == 0) {
        department_and_dates['employment_end_date'] = moment(res.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }

    // Handle rehire status if feature flag is active and status is Candidate
    if (this.ENT_10167_ADD_TARGET_STATUS_TO_MULTI_EDIT
      && res.status && res.status.value === 'Candidate' && res.rehireStatus) {
      department_and_dates['rehire_status'] = res.rehireStatus.label;
    }

    // Detect if this is from Talent Pool tab
    const isTalentPool = this.selectedTab === 'talent_pool';
    // Call appropriate async endpoint
    const updateObservable = isTalentPool
      ? this.peopleService.updateTalentPoolAll(res?.status?.label, this.searchOutput,
      this.sortString,
      this.rowsPerView,
      this.currentPage,
      this.filterOutput, department_and_dates)
      : this.peopleService.updatePeopleAll(res?.status?.label, this.searchOutput,
      this.sortString,
      this.rowsPerView,
      this.currentPage,
      this.filterOutput,
      this.status,
      this.selectedPeople.map(e => e.uid).join(','), department_and_dates);

    updateObservable.subscribe(response => {
      setTimeout(() => {
        // This will call initialisePeople() or initialiseTalentPool()
        // which automatically sets this.loading = false when done
        this.onSelectTab({'id': this.selectedTab});
        this.setSelectMode(false);
        if (res?.status?.label == 0 && this.invalidSelectedPeople.length > 0) {
          const message = this.buildUpdateStatusMessage(
            this.validSelectedPeople.length,
            this.invalidSelectedPeople.length
          );

          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: message,
            keepOnRouteChange: true
          }]);
          this.setSelectMode(true);
          this.selectedPeople = this.people.filter(person => {
            const isSelected = this.invalidSelectedPeople.includes(person.uid);
            person.selected = isSelected;
            return isSelected;
          });
          this.peopleService.selectedPeople = this.selectedPeople;
        }
        if (res?.status?.label != 0) {
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Selected profiles have been updated.`,
            keepOnRouteChange: true
          }]);
        }
      }, 5000);
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.loading = false;
    });
  }

  private buildUpdateStatusMessage(validCount: number, invalidCount: number): string {
    const validPlural = validCount === 1 ? 'profile has' : 'profiles have';
    const invalidWasWere = invalidCount === 1 ? 'was' : 'were';
    const invalidRemains = invalidCount === 1 ? 'remains' : 'remain';

    return $localize`Success! ${validCount} ${validPlural} been updated. ${invalidCount} ${invalidWasWere} not updated and ${invalidRemains} selected.`;
  }


  onSelectTab(event, filterChange=false){
    window.scrollTo(0, 0);
    setTimeout(()=>{
      const state = this.planservice.getPlanState();
      if(state.user_role!="support" && state.user_role!="viewer" && state.user_role!='member (restricted)'){
        this.isEditButton=true;
      }
   }, 500);

    if (this.selectedTab !== event.id) {
      this.currentPage = 1;
    }

    this.selectedTab = event.id;
    const savedSearch = localStorage.getItem(`${this.selectedTab}_search`);
    if (savedSearch) {
      const parsedSearch = JSON.parse(savedSearch);
      this.searchOutput = parsedSearch.searchOption;
      this.selectedColumns = parsedSearch.selectedColumns;
      this.addOrder = parsedSearch.addOrder;
      this.searchTags = parsedSearch.searchTags;

  }
    if(!filterChange && this.filterOutput['department_id'] && this.filterOutput['department_category_id']){
        delete this.filterOutput['department_id'];
        delete this.filterOutput['department_category_id'];
    }
    if (!filterChange && this.filterOutput['filterBy']) {
      delete this.filterOutput['filterBy'];
    }
    if (!filterChange) {
      // Only reset to default if NOT returning from profile page
      if (this.selectedTab === 'talent_pool' && sessionStorage.getItem('talentPoolProfileNav') !== 'true') {
        this.filterOutput['filter'] = $localize`Last 30 days`;
        this.filterOutput['start_date'] = moment().startOf('day').subtract(30, 'days');
        this.filterOutput['end_date'] = moment();
        this.filterOutput['statusOption'] = ['Target', 'Potential target'];
        if (this.filterOutput['optInOption']) {
          delete this.filterOutput['optInOption'];
        }
        if (this.filterOutput['location']) {
          delete this.filterOutput['location'];
          delete this.filterOutput['distance'];
        }
        if (!['name', '-name', 'opt_in', '-opt_in', 'grouped', '-grouped'].includes(this.sortString)) {
          this.sortString = '-opt_in';
        }
      } else if (this.selectedTab !== 'talent_pool') {
        if (this.sortString == 'opt_in' || this.sortString == '-opt_in') {
          this.sortString = '-activities';
        }
        if (this.filterOutput['filter']) {
          delete this.filterOutput['filter'];
        }
      }
    }
    localStorage.setItem('people-page-selected-tab', this.selectedTab);
    if (this.selectedTab == 'all'){
      this.status = null;
      if(this.canViewPeople){
        this.initialisePeople();
      }else{
        this.loading = false;
      }

    } else if(this.selectedTab === 'ex-employees') {
      this.status = '0';
      if(this.canViewPeople){
        this.initialisePeople();
      }else{
        this.loading = false;
      }

    } else if(this.selectedTab === 'employees') {
      this.status = '1';
      if(this.canViewPeople){
        this.initialisePeople();
      }
      else{
        this.loading = false;
      }

    } else if(this.selectedTab === 'candidates') {
      this.status = '3';
      if(this.canViewPeople){
        this.initialisePeople();
      }else{
        this.loading = false;
      }
    } else {
      if(this.canViewPeople){
        this.initialiseTalentPool();
      }else{
        this.loading = false;
      }

    }
  }

  storeSearch(tab=this.selectedTab) {
      const dumped_data = {
        searchOption: this.searchOutput,
        selectedColumns: this.selectedColumns,
        addOrder: this.addOrder,
        searchTags: this.searchTags
      }
      localStorage.setItem(`${tab}_search`, JSON.stringify(dumped_data));
    }


  onPageChange(pageNumber){
    this.selectAllPage = false;
    if (!this.selectAllTotal) {
      this.selectedPeopleAll = [];
      this.allInMemory = false;
    }
    this.currentPage = pageNumber;

    this.onSelectTab({'id':this.selectedTab}, true);
  }

  onPageSizeChange(rowsPerView){
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;

    this.onSelectTab({'id':this.selectedTab}, true);
  }

  onSortChange(sortString:any): void{
    this.sortString = sortString;
    this.onSelectTab({'id':this.selectedTab});
  }

  sortSelectedGroups() {
    let totalSelected = this.selectedPeople.length;
    if (totalSelected) {
      let people = this.people.filter(p => p.selected !== true)
      let newPeopleArray: any[] = [];
      let minAmount = (this.currentPage - 1) * this.rowsPerView + 1;
      let maxAmount = this.currentPage * this.rowsPerView;
      if (this.sortString === 'grouped') {
        if (totalSelected >= minAmount && totalSelected <= maxAmount) {
          for (let i = minAmount - 1; i < totalSelected; i++) {
            this.selectedPeople[i].selected = true;
            newPeopleArray.push(this.selectedPeople[i]);
          }
          let pageSelected = totalSelected - minAmount + 1;
          let remaining = this.rowsPerView - pageSelected;
          if (pageSelected < this.rowsPerView) {
            for (let i = 0; i < remaining; i++) {
              newPeopleArray.push(people[i]);
            }
          }
          this.people = newPeopleArray;
        } else if (totalSelected > maxAmount) {
          for (let i = minAmount - 1; i < maxAmount; i++) {
            newPeopleArray.push(this.selectedPeople[i]);
          }
          this.people = newPeopleArray;
        }
      } else if (this.sortString === '-grouped') {
        let unselected = this.total - this.selectedPeople.length;
        if (this.total < maxAmount) {
          maxAmount = this.total
        }

        if (unselected >= minAmount && unselected <= maxAmount) {
          let pageSelected = unselected - minAmount + 1;
          let remaining = this.selectedPeople.length < (this.rowsPerView - pageSelected) ? this.selectedPeople.length : (this.rowsPerView - pageSelected)
          for (let i = 0; i < pageSelected; i++) {
              newPeopleArray.push(people[i]);
          }
          for (let i = 0; i <= remaining - 1; i++) {
            this.selectedPeople[i].selected = true;
            newPeopleArray.push(this.selectedPeople[i]);
          }
          this.people = newPeopleArray;
        } else if (minAmount > unselected) {
          for (let i = minAmount - unselected - 1; i < maxAmount  - unselected; i++) {
            newPeopleArray.push(this.selectedPeople[i]);
          }
          this.people = newPeopleArray;
        }
      }
    }
  }

  onSearchChange(searchOutput){
    this.searchTags = [...this.searchTags]
    this.searchTags.unshift(searchOutput)
    this.searchOutput = this.createSearchOutput()
    this.storeSearch();
    this.onSelectTab({'id': this.selectedTab}, true);
  }

  onFilterUpdate(event){
    this.filterByVar = event?.filterByVar ? event.filterByVar : this.filterByVar
    this.filterOutput = event;
    this.onSelectTab({'id':this.selectedTab}, true);
  }

  onViewProfile(id){
    // Set session flag if navigating from talent pool tab
    if (this.selectedTab === 'talent_pool') {
      sessionStorage.setItem('talentPoolProfileNav', 'true');
    }
    this.router.navigate([`/people/profile/${id}`]);
  }

  onSelectProfile(id) {
    if (this.selectAllPage || this.selectAllTotal) {
      this.selectAllPage = false;
      this.selectAllTotal = false;
      this.peopleService.selectedPeople = [];
      this.selectedPeopleAll = [];
      this.allInMemory = false;
    } else {
      this.peopleService.selectedPeople = this.selectedPeople;
    }
  }

  setSelectMode(on) {
    if (on) {
      this.selectMode = true;
      if (this.selectedTab == 'talent_pool') {
        this.sortOptionsTalentPool = [
          ...this.sortOptionsTalentPool,
          {
            label: $localize`Selected profiles`,
            type: 'grouped',
            value: 'grouped',
          },
        ];
      } else {
        this.sortOptionsUpdated = [
          ...this.sortOptionsUpdated,
          {
            label: $localize`Selected profiles`,
            type: 'grouped',
            value: 'grouped',
          },
        ];
      }
    }
  }

  clearSelectAll() {
    this.selectAllPage = false;
    this.selectAllTotal = false;
    this.selectMode = false;
    this.selectedPeople = [];
    this.peopleService.selectedPeople = [];
    this.selectedPeopleAll = [];
    this.allInMemory = false;
    this.people.forEach((person, index) => {
      if (person) {
        person.selected = false;
      }
    })
  }

  setSelectAllMode() {
    this.selectAllPage = true;
    this.people.forEach((person, index) => {
      person.selected = true;
      if (!this.selectedPeople.some(s => s.uid === person.uid)) {
        this.selectedPeople.push(person);
      }
    })
  }

  setSelectTotal() {
    this.selectAllTotal = true;
    this.selectAllPage = false;
  }

  sendRequest(){
    const state = this.planservice.getPlanState()
    const valid_start_time =state.valid_from
    const current_time = state.current_time
    const valid_end_time = state.valid_till
    if(state.message != 'No plans found'){
      if (valid_start_time > current_time){
        const formattedDate = moment.utc(valid_start_time).local().format('ll')
        const initialState={
            message:$localize`Almost there! Your subscription will be activated on ${formattedDate}.`,
            showLink:false
        }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
        );
        }
        else{
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new', initialState}),
        );
        }

        const metaData = {
          "log":{
            "organisation_id": this.org_uid,
            "message": "Subscription not yet started"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)

    }else if(valid_start_time<current_time && valid_end_time<current_time){
        const formattedDate =moment.utc(valid_end_time).local().format('ll')
        let initialState = {
            message: $localize`Unfortunately, your subscription expired on ${formattedDate}. `,
            showLink: this.canViewContactAccountManagerLink
          }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
                SelectRequestModalComponent,
                Object.assign({}, {class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
            );
        }
        else {
            this.bsModalRef = this.modalService.show(
                SelectRequestModalComponent,
                Object.assign({}, {class: 'modal-dialog-centered select-survey-new', initialState}),
            );
        }
        const metaData = {
        "log":{
          "organisation_id": this.org_uid,
          "message": "Subscription expired"
        },
        "audit_log": "CLICK_REQUEST_FORBIDDEN"
      }
      this.planservice.postLog(metaData)
    }else if(valid_start_time<current_time && valid_end_time>current_time && (state.active==false || state.payment_status===2)) {
        let initialState = {
            message: $localize`Unfortunately, your subscription is pending activation. `,
            showLink: this.canViewContactAccountManagerLink
          }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
            SelectRequestModalComponent,
            Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
            );
        }
        else{
            this.bsModalRef = this.modalService.show(
            SelectRequestModalComponent,
            Object.assign({}, { class: 'modal-dialog-centered select-survey-new', initialState}),
            );
        }

        const metaData = {
          "log":{
            "organisation_id": this.org_uid,
            "message": "Subscription unpaid or inactive"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)
      }else{
        this.sendRequestFunction()
      }
    }else{
      let initialState = {
          message: $localize`Unfortunately, your subscription is pending activation. `,
          showLink: this.canViewContactAccountManagerLink
        }
      if(this.requestTemplate){
          this.bsModalRef = this.modalService.show(
        SelectRequestModalComponent,
        Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
      );
      }
      else{
          this.bsModalRef = this.modalService.show(
        SelectRequestModalComponent,
        Object.assign({}, { class: 'modal-dialog-centered select-survey-new', initialState}),
      );
      }

      const metaData = {
        "log":{
          "organisation_id": this.org_uid,
          "message": "Subscription unpaid or inactive"
        },
        "audit_log": "CLICK_REQUEST_FORBIDDEN"
      }
      this.planservice.postLog(metaData)
    }
  }


  sendRequestFunction() {
    if (!((this.selectAllTotal && this.total > 5000) || this.selectedPeople.length > 5000))  {
      if (this.selectAllTotal) {
        this.getSelectedPeopleSendXref()
      } else {
        this.peopleService.selectedPeople = this.selectedPeople;
        this.updateSelectedPeopleEmails();
        this.formatSelectedPeopleData();
        this.openSelectReferenceModal();
      }
    }
  }

  updateSelectedPeopleEmails() {
    if (!this.peopleService.selectedPeople) return;
    this.peopleService.selectedPeople.forEach(person => {
      if (person.person_email_list) {
        // Find personal email (type 1) with non-empty email
        const personal = person.person_email_list.find(([email, type]) => type === 1 && email && email.trim() !== '');
        if (personal) {
          person.email = personal[0];
          return;
        }
        // Find work email (type 0) with non-empty email
        const work = person.person_email_list.find(([email, type]) => type === 0 && email && email.trim() !== '');
        if (work) {
          person.email = work[0];
          return;
        }
      }
      // Fallback: keep existing person.email
    });
  }

  openSelectReferenceModal() {
    this.selectCheckTypeModal = this.modalService.show(
      SelectCheckTypeModalComponent,
      Object.assign({}, { class: 'modal-dialog-centered select-reference-modal'}),
    );
    this.selectCheckTypeModal.content.closeBtnName = 'Close';
    if(this.requestTemplate){
        this.selectCheckTypeModal.content.selectClick.subscribe(res => {
      this.router.navigateByUrl('/request', { state: { checkType: res.data, template: res?.template, preFill: true } });
    });
    }
    else{
        this.selectCheckTypeModal.content.selectClick.subscribe(res => {
      this.router.navigateByUrl('/request', { state: { checkType: res.data, preFill: true } });
    });
    }
  }

  createSearchOutput(){
    return this.searchTags.map(item => ({
      key: item.value === '' ? 'all' : item.value,
      value: item.term
    }));
  }
  onRemoveSearchTag(searchOutput){
    this.searchTags = searchOutput
    this.searchOutput = this.createSearchOutput()
    this.storeSearch();
    this.onSelectTab({'id': this.selectedTab}, true);
  }

  onRequestAccess($event: any) {
    this.permissions.requestAccess(
      {
        template_type: 'people'
      }
    ).subscribe(
      (res) => {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Your request has been sent successfully. You will be notified once your request has been approved.`,
          keepOnRouteChange: true
        }]);
      },
      (error) => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    )

  }
}
